import { Trait } from '../../trait.type';
import { ModifierPriority } from '../../modifier.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';
import { addModifier } from '../../player.type';
import type { Player } from '../../player.type';
import type { Die } from '../../die.type';

export class BarbarianTrait extends Trait {
  static baseType = TraitType.Barbarian;
  static baseTitle = "Barbarian's Rage";
  static baseText =
    'Gain 1 Regeneration for every instance of damage taken, but remove all Regeneration at the start of your turn.';
  static baseIcon = 'trait';

  type = BarbarianTrait.baseType;
  title = BarbarianTrait.baseTitle;
  text = BarbarianTrait.baseText;
  icon = BarbarianTrait.baseIcon;

  init(): void {
    this.priority = ModifierPriority.Late;
  }

  damageIn(): void {
    addModifier(this.owner, StatusEffect.Regen, 1);
  }

  startTurn({
    dice,
    rerollMax,
    activePlayer,
    inactivePlayer,
  }: {
    dice: Die[];
    rerollMax: number;
    activePlayer: Player;
    inactivePlayer: Player;
  }): void | { dice: Die[]; rerollMax: number; activePlayer: Player; inactivePlayer: Player } {
    const regeneration = this.owner.statusEffects.find(
      (modifier: any) => modifier.type === StatusEffect.Regen,
    );
    regeneration?.removeStacks(regeneration.stacks);
  }
}

TraitRegistry.register(BarbarianTrait.baseType, BarbarianTrait);
